import map from 'lodash/map'
import { useCallback } from 'react'
import { useFetchRefactored, useSuccessNotification } from 'civic-champs-shared/api/hooks'
import { useCurrentOrg } from 'auth/hooks'
import { Group } from 'Event/components/opportunity/GroupPicker/types'
import { Action, BulkAction } from 'civic-champs-shared/api/hooks/useRemoteCollection'

export const useArchiveGroups = (eagerReplaceMany: BulkAction<Group>) => {
  const [fetch] = useFetchRefactored()
  const showSuccess = useSuccessNotification()
  const organization = useCurrentOrg()

  return useCallback(async (
    groups: Group[], 
    archived: boolean = true
  ) => {
    const action = `${archived ? '' : 'un'}archive`
    const undo = eagerReplaceMany(map(groups, group => ({ ...group, archivedAt: archived ? new Date() : undefined })))
    try {
      return fetch({
        method: 'post',
        url: `/organizations/${organization.id}/archive_groups`,
        config: {
          body: {
            groupIds: map(groups, 'id'),
            archived
          }
        },
        successMessage: `Groups successfully ${action}d`,
        errorMessage: `Failed to ${action} groups`
      })
    } catch(error) {
      undo()
    }
  }, [showSuccess])
}
